import {Component, ElementRef, Host, Inject, Input, OnInit, Optional, Self, ViewChild} from '@angular/core';
import {UIBaseControlComponent} from "../ui-base-control/ui-base-control.component";
import {NgControl, NgModel, ValidationErrors} from "@angular/forms";
import {UI_INPUT_VALIDATION_ERROR_TOKEN} from "../ui-base-control/ui-input-validation-error-token";

@Component({
  selector: 'ui-input',
  templateUrl: './ui-input.component.html',
  styleUrls: ['./ui-input.component.scss']
})
export class UIInputComponent extends UIBaseControlComponent implements OnInit {
  @Input() type: any;
  @Input() placeholder = '';
  @Input() isTextarea = false;
  @Input() rows = 4;

  @ViewChild('input', { static: true })
  input: ElementRef;
  formControl: any;
  @Input() icon: string;

  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl,
    @Optional()
    @Host()
    @Inject(UI_INPUT_VALIDATION_ERROR_TOKEN)
    public customErrors: ValidationErrors
  ) {
    super(ngControl, customErrors);
  }
  private onInputChange() {
    const input = this.input.nativeElement;
    // get value from text area
    const newValue = input.value;

    // update the form
    this.onChange(newValue);
  }

  ngOnInit() {
    super.ngOnInit();

    // support for value change by [(ngModel)]
    if (this.ngControl instanceof NgModel) {
      const inputElement = this.input.nativeElement;
      inputElement.onchange = () => this.onInputChange();
      inputElement.onkeyup = () => this.onInputChange();
    }
  }

}
